import { Controller } from "@hotwired/stimulus"

// The birthday preview follows the existing one/four/eight-column chip grid.
export default class extends Controller {
    static targets = ["grid", "button"]

    connect() {
        this.measure = () => {
            const columns = getComputedStyle(this.gridTarget).gridTemplateColumns.split(" ").length
            this.buttonTarget.hidden = this.gridTarget.children.length <= columns * 2
        }
        this.observer = new ResizeObserver(this.measure)
        this.observer.observe(this.gridTarget)
        this.measure()
    }

    disconnect() { this.observer?.disconnect() }

    toggle() {
        const collapsed = this.gridTarget.classList.toggle("is-collapsed")
        this.buttonTarget.textContent = collapsed ? "Show all birthdays" : "Show less"
        this.buttonTarget.setAttribute("aria-expanded", String(!collapsed))
    }
}
